<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.masterReport')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="sales-report">
      <div class="row mar-bt-15">
        <!-- Left Column -->
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <template v-for="loc in locations">
                <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
              </template>
            </select>
          </div>

          <div class="mb-3 w-100" v-if="posUsers.length">
            <label class="form-label text-start w-100">{{$t('reports.operator')}}</label>
            <select class="form-control mar-bt-15" v-model="selectedPosUser">
              <option value="null" selected :label="$t('general.alls')">{{$t('general.alls')}}</option>
              <template v-for="operator in posUsers">
                <option :label="operator.firstname + ' ' + operator.lastname" :value="operator.id">
                  {{operator.firstname}} {{operator.lastname}}
                </option>
              </template>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('general.orderId')}}</label>
            <input 
              type="number"
              min="0"
              name="price"
              placeholder="3823231"
              v-model="orderId"
              class="form-control">
          </div>

          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('reports.tables')}}</label>
            <el-select
              v-model="selectedTables"
              ref="tableSelect"
              value-key="id"
              multiple
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              :placeholder="$t('settingTable.searchTable')"
              :remote-method="searchTables"
              :loading="loadingTables"
              @change="clearSearch">
              <el-option
                v-for="item in mergedTables"
                :key="item.id"
                :label="item.label"
                :value="item">
              </el-option>
            </el-select>
          </div>

          <!-- <div class="pull-left mar-to-38">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
          </div> -->
        </div>
      </div>

      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;"> {{ $t('reports.lastSearch')}}: <b>{{ currentTime }}</b> <span :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></span></p>  
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-content total-pagination reports-center-columns" style="width: 100%;">
            <data-tables-server
              @query-change="paginationChanged"
              v-loading="loading"
              :data="productsTableData"
              :total="totalOrders"
              :pagination-props="paginationProps"
              class="report-sales"
              ref="reportsTable"
            >
              <el-table-column class-name="centered-cell" prop="order_id" :label="$t('reports.orderId')" min-width="100"/>
              <el-table-column class-name="centered-cell" prop="table_number" :label="$t('reports.tableNumber')" min-width="100">
                <template slot-scope="props">
                  {{ props.row.table_number ? props.row.table_number : '-' }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="table_zone" :label="$t('orders.zone')" min-width="100">
                <template slot-scope="props">
                  {{ props.row.table_zone ? props.row.table_zone : '-' }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="pos_id" :label="$t('reports.posId')" min-width="100"/>
              <el-table-column class-name="centered-cell" prop="operator_name" :label="$t('reports.operator')" min-width="140"/>

              <el-table-column class-name="centered-cell" prop="order_opening_time" :label="$t('reports.orderCreatedAt')" min-width="160">
                <template slot-scope="props">
                  {{ props.row.order_opening_time ? formatToCompanyTimezone(props.row.order_opening_time) : '-' }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="order_duration" :label="$t('reports.duration')" min-width="130"/>
              <el-table-column class-name="centered-cell" prop="order_number" :label="$t('reports.orderNumber')" min-width="130"/>
              <el-table-column class-name="centered-cell" prop="product_count" :label="$t('reports.productCount')" min-width="140"/>
              <el-table-column class-name="centered-cell" prop="order_total" :label="$t('orders.totals_grandtotal')" min-width="140"/>
              <el-table-column class-name="centered-cell" prop="payment_type" :label="$t('reports.paymentMethod')" min-width="140">
                <template slot-scope="props">
                  {{ $t('paymentTypes.' + props.row.payment_type) }}
                </template>
              </el-table-column>
              <el-table-column class-name="centered-cell" prop="order_comments" :label="$t('reports.orderComments')" min-width="140"/>
            </data-tables-server>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert2'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import {Select, DatePicker} from 'element-ui'

export default {
  components: {
    // GeneralTopBar,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker
  },
  props: {
    isTableOpenOrderReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isTableOpenOrderReport () {
      if (this.isTableOpenOrderReport) {
        this.getOrders()
      }
    }
  },
  created () {
    this.getOrders()
    const currentDate = new Date()
    const formattedDate = currentDate.getDate() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getFullYear()
    this.export_name = this.$session.get('selectedCompanyData')['name'] + '-' + formattedDate + '.xls'
    this.verifyUserLocations()
    this.verifyUserMethods()
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
    this.getPosUsers()
  },
  data () {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      currentTime: this.formatToCompanyTimezone(),
      selectedTables: [],
      availableTables: [],
      allTablesMap: new Map(),
      posUsers: [],
      productsTableData: [],
      selectedPosUser: null,
      timezone: null,
      orderId: null,
      loading: true,
      loadingTables: false,
      orders: {
        // 'valid': [  // luna curenta
        //   moment().date(1).format('YYYY-MM-DD'),
        //   moment().endOf('month').format('YYYY-MM-DD')
        // ],
        'valid': [
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      totalOrders: null,
      noData: false,
      pagination: {
        page: 1,
        pageSize: 20
      }
    }
  },
  computed: {
    mergedTables () {
      const map = new Map(this.availableTables.map(t => [t.id, t]))
      this.selectedTables.forEach(t => {
        if (!map.has(t.id)) {
          map.set(t.id, t)
        }
      })
      return Array.from(map.values())
    }
  },
  methods: {
    searchTables (query) {
      if (!query) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: query
      }

      this.loadingTables = true

      this.apiRequest('/search-tables', 'GET', data, response => {
        if (response.status) {
          response.data.forEach(item => {
            this.allTablesMap.set(item.id, item)
          })

          this.availableTables = response.data
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loadingTables = false
        })
      })
    },
    clearSearch () {
      this.$refs.tableSelect.focus()
      const select = this.$refs.tableSelect

      if (select) {
        select.query = ''
        select.handleQueryChange('')
      }
    },
    formatToCompanyTimezone (utcString) {
      let date = ''
      if (!utcString) {
        date = new Date()
      } else {
        date = new Date(utcString + 'Z')
      }

      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })

      const parts = formatter.formatToParts(date)

      return `${parts.find(p => p.type === 'year').value}-${
        parts.find(p => p.type === 'month').value}-${
        parts.find(p => p.type === 'day').value} ${
        parts.find(p => p.type === 'hour').value}:${
        parts.find(p => p.type === 'minute').value}:${
        parts.find(p => p.type === 'second').value}`
    },
    changeValidFrom () {
      // if (this.valid_to <= this.valid_from) {
      //   this.valid_to = '23:59'
      // }
      if (!this.valid_from) {
        this.valid_from = '05:00'
      }
      if (!this.valid_to) {
        this.valid_to = '05:00'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        this.pagination.page = query.page
        this.pagination.pageSize = query.pageSize
        this.getOrders(query)
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isTableOpenOrderReport) {
        return
      }
      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        order_id: this.orderId,
        operator: this.selectedPosUser
      }

      if (this.selectedTables && this.selectedTables.length) {
        data.table_ids = this.selectedTables.map(table => table.id)
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      const pageSize = query ? query.pageSize : this.pagination.pageSize
      const page = query ? query.page : this.pagination.page

      this.apiRequest('/reports/v2/table-open-orders?page=' + page + '&perPage=' + pageSize, 'GET', data, response => {
        if (response.status) {
          this.productsTableData = response.data
          this.totalOrders = response.pagination.total
          this.paginationProps.currentPage = response.pagination.page
          this.paginationProps.pageSize = response.pagination.perPage
          this.pagination.page = response.pagination.page
          this.pagination.pageSize = response.pagination.perPage
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.currentTime = this.formatToCompanyTimezone()
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    getPosUsers () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.posUsers = response.data.pos_user
        }
      })
    }
  }
}
</script>
<style>
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

<style scopped>
  .el-select .el-tag {
    background-color: #674BD2 !important;
    color: white;
    /* font-size: 16px; */
    padding: 2px 12px;
  }

  span .el-tag {
    padding-top: 7px !important;
    height: 36px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/TableOpenOrderReport.vue